import axios from "axios";
import {
	CHANGE_PRICE,
	GET_PRODUCT,
	GET_PRODUCT_ERROR,
	GET_ALERTS,
	GET_ALERTS_ERROR,
	SAVE_ALERTS,
} from "./types";
import { toastr } from "react-redux-toastr";
import { logout } from "./auth";

// The Settings page: prices (/api/product), who gets the mails about the kiosks
// with the low paper numbers (/api/settings/alerts), and the ads page (/api/ads)

// Shows the backend's { errors: [{ msg }] } and logs out on an expired token
const handleError = (err, dispatch) => {
	// No response: the network or the server is down
	if (!err.response) {
		toastr.error("Сервертэй холбогдож чадсангүй");
		return;
	}
	if (err.response.status === 401 && err.response.data.msg === "Token is not valid") {
		window.localStorage.clear("x-auth-token");
		toastr.error("Session expired");
		dispatch(logout());
	}
	const errors = err.response.data.errors;
	if (errors) {
		errors.forEach((error) => toastr.error(error.msg));
	}
};

const config = {
	headers: {
		"Content-Type": "application/json",
	},
};

//  Get product
export const getProduct = () => async (dispatch) => {
	try {
		const res = await axios.get("/api/product");
		dispatch({
			type: GET_PRODUCT,
			payload: res.data,
		});
	} catch (err) {
		dispatch({ type: GET_PRODUCT_ERROR });
		handleError(err, dispatch);
	}
};

// Change price. Returns whether it was saved, for the row to settle. A row with no
// _id is a photo row before its first price, which /api/product/photo adds.
export const changePrice = (item, price) => async (dispatch) => {
	try {
		const res = item._id
			? await axios.put("/api/product", JSON.stringify({ productId: item._id, price }), config)
			: await axios.put("/api/product/photo", JSON.stringify({ price, type: item.type }), config);
		dispatch({
			type: CHANGE_PRICE,
			payload: res.data,
		});
		toastr.success("Үнэ хадгалагдлаа");
		return true;
	} catch (err) {
		handleError(err, dispatch);
		return false;
	}
};

//  Who gets each mail, the low paper numbers, and the admins to pick from
export const getAlerts = () => async (dispatch) => {
	try {
		const res = await axios.get("/api/settings/alerts");
		dispatch({
			type: GET_ALERTS,
			payload: res.data,
		});
	} catch (err) {
		dispatch({ type: GET_ALERTS_ERROR });
		handleError(err, dispatch);
	}
};

//  Saves every mail and number at once. Returns { alerts } or the backend's
//  { errors }, for the page to show.
export const saveAlerts = (body) => async (dispatch) => {
	try {
		const res = await axios.put("/api/settings/alerts", JSON.stringify(body), config);
		dispatch({
			type: SAVE_ALERTS,
			payload: res.data,
		});
		toastr.success("Хадгалагдлаа");
		return { alerts: res.data };
	} catch (err) {
		handleError(err, dispatch);
		return {
			errors: (err.response && err.response.data.errors) || [],
		};
	}
};

//  Mails the saved recipients of one alert. mailed is false when the backend has no
//  mailPass and only printed the mail: nobody got it.
export const testAlert = (key) => async (dispatch) => {
	try {
		const res = await axios.post(`/api/settings/alerts/${key}/test`);
		if (res.data.mailed === false) {
			toastr.warning(
				"Туршилтын мэйл илгээгдсэнгүй: серверт mailPass тохируулаагүй тул серверийн log-д хэвлэгдлээ",
			);
		} else {
			toastr.success(`Туршилтын мэйл илгээлээ: ${res.data.to}`);
		}
		return true;
	} catch (err) {
		handleError(err, dispatch);
		return false;
	}
};

//  What cloudprint.mn/advertise shows businesses about ads on the kiosk screens
//  (/api/ads), or null when it could not be loaded. Kept on the page, not in the store.
export const getAds = () => async (dispatch) => {
	try {
		const res = await axios.get("/api/ads");
		return res.data;
	} catch (err) {
		handleError(err, dispatch);
		return null;
	}
};

//  Saves all of it at once. Returns { ads } as the backend cleaned it up, or its
//  { errors }.
export const saveAds = (body) => async (dispatch) => {
	try {
		const res = await axios.put("/api/ads", JSON.stringify(body), config);
		toastr.success("Хадгалагдлаа");
		return { ads: res.data };
	} catch (err) {
		handleError(err, dispatch);
		return {
			errors: (err.response && err.response.data.errors) || [],
		};
	}
};
